import { atom } from 'recoil';
import { AtomKeys } from 'stores/storeKeys';
import { AcctStateRefResponseType } from 'types/api/acctStateRefResponseType';
/**
 * ワークスペース共通項目
 */
export type AcctStateType = AcctStateRefResponseType & {
  initialized: boolean;
  proxyLogin: boolean;
  proxyCompanyCd: string | null;
};

export const AcctState = atom<AcctStateType>({
  key: AtomKeys.ACCT_STATE,
  default: {
    user: null,
    company: null,
    usage: null,
    activeContent: null,
    initialized: false,
    proxyLogin: false,
    proxyCompanyCd: null,
  },
});
